import type { AgentId, EntityId, TenantId } from './entity-id.js';

export type TrustStatus = 'verified' | 'registered' | 'unverified' | 'suspended' | 'revoked';

export interface AgentIdentity {
  id: AgentId;
  publicKey: string;
  secretKey?: string;
  ownerId: EntityId;
  tenantId: TenantId;
  status: 'active' | 'suspended' | 'revoked';
  trustStatus: TrustStatus;
  createdAt: number;
}

export function createAgentIdentity(params: {
  id: AgentId;
  ownerId: EntityId;
  tenantId: TenantId;
  publicKey?: string;
  secretKey?: string;
}): AgentIdentity {
  const secretKey = params.secretKey || `sk_${Math.random().toString(36).substring(2)}${Math.random().toString(36).substring(2)}`;
  const publicKey = params.publicKey || `pk_${Math.random().toString(36).substring(2)}`;

  return {
    id: params.id,
    publicKey,
    secretKey,
    ownerId: params.ownerId,
    tenantId: params.tenantId,
    status: 'active',
    trustStatus: 'verified',
    createdAt: Date.now(),
  };
}

export function signPayload(payload: string, secretKey: string): string {
  // Simple HMAC/hash signature simulation for Phase 1
  let hash = 0;
  const combined = `${payload}:${secretKey}`;
  for (let i = 0; i < combined.length; i++) {
    const char = combined.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return `sig_${Math.abs(hash).toString(16)}_${payload.length}`;
}

export function verifySignature(payload: string, signature: string, secretKey: string): boolean {
  if (!signature || !signature.startsWith('sig_')) return false;
  const expected = signPayload(payload, secretKey);
  return expected === signature;
}
